import React, { useState } from "react";
import "../style.css";

const carouselData = [
  {
    img: "https://cdn.shopify.com/s/files/1/2185/2813/files/W9680R_0100_b2_s1_a2_1_m191_640x.jpg?v=1761808266",
    brand: "Alo",
    name: "Airbrush High-Waist Heart Throb",
    price: "$88.00",
    location: "Flatiron"
  },
  {
    img: "https://us.princesspolly.com/cdn/shop/files/1-modelinfo-mia-us4_2bb3cf74-5a70-46b3-999b-39809bb1bb7e.jpg?v=1736831930&width=1800",
    brand: "PRINCESS POLLY",
    name: "Marguerite Halter Maxi Dress White Pol...",
    price: "$34.00",
    originalPrice: "$85.00",
    discount: "-60%",
    location: "Broadway"
  },
  {
    img: "https://danielleguiziony.com/cdn/shop/files/OCT141281.jpg?v=1760729326",
    brand: "GUIZIO",
    name: "Roxie Faux Fur Coat",
    price: "$148.00",
    originalPrice: "$328.00",
    discount: "-55%",
    location: "NYC Flagship"
  },
  {
    img: "https://static.zara.net/assets/public/209a/3516/c878489a9238/0d830c767b85/09598441485-e1/09598441485-e1.jpg?ts=1783954012929&w=1500",
    brand: "ZARA",
    name: "Relaxed Fit Knit T-Shirt",
    price: "$49.90",
    location: "SOHO"
  },
  {
    img: "https://qf-images-8-1.s3.us-east-1.amazonaws.com/onsale_mens_grey.png",
    brand: "Theory",
    name: "Standard Chino Short in Moonsoft Cotton",
    price: "$99.00",
    originalPrice: "$165.00",
    discount: "-40%",
    location: "Flatiron"
  },
  {
    img: "https://qf-images-8-1.s3.us-east-1.amazonaws.com/onsale_mens_green.png",
    brand: "On",
    name: "Club-T",
    price: "$50.00",
    originalPrice: "$89.00",
    discount: "-44%",
    location: "Flatiron"
  },
  {
    img: "https://qf-images-8-1.s3.us-east-1.amazonaws.com/female_on_sale_carousel_1.png",
    brand: "Princess Polly",
    name: "Ramie Strapless Mini Dress Burgundy Low Impact",
    price: "$29.00",
    originalPrice: "$75.00",
    discount: "-61%",
    location: "Broadway"
  },
  {
    img: "https://qf-images-8-1.s3.us-east-1.amazonaws.com/female_on_sale_carousel_2.png",
    brand: "Aritzia",
    name: "Godard Dress",
    price: "$37.99",
    originalPrice: "$128.00",
    discount: "-70%",
    location: "SoHo Flagship"
  },
  {
    img: "https://cdn.shopify.com/s/files/1/2185/2813/files/A0590U_01010_b1_s1_a1_2e75864b-d696-40a3-bcb7-8d5b713206e5_640x.jpg?v=1739918924",
    brand: "Alo",
    name: "Alo Runner",
    price: "$195.00",
    location: "Flatiron" 
  },
  {
    img: "https://cdn.shopify.com/s/files/1/0512/3103/1472/files/sharni-top-black-with-jean-01.jpg?v=1758165481",
    brand: "withjean",
    name: "Sharni Top",
    price: "$144.00",
    location: "NYC"
  },
  {
    img: "https://cdn.shopify.com/s/files/1/0512/3103/1472/files/rose-top-red-with-jean-01.jpg?v=1748466979",
    brand: "withjean",
    name: "Rose Top (Red)",
    price: "$149.00",
    location: "NYC"
  },
  {
    img: "https://skims.imgix.net/s/files/1/0259/5448/4284/products/SKIMS-SHAPEWEAR-BD-THG-3369-IA-SIE_0005_FR.jpg?v=1682133873&auto=format&w=600&fp-z=1&fp-y=0.5&fp-x=0.5&crop=focalpoint&fit=crop&ixlib=react-9.10.0",
    brand: "SKIMS",
    name: "Strapless Thong Bodysuit",
    price: "$70.00",
    location: "Flagship"
  },
  {
    img: "https://cdn.shopify.com/s/files/1/2185/2813/files/W4493R_01_b2_s1_a2_1_m177_640x.jpg?v=1761808266",
    brand: "Alo",
    name: "Foxy Sherpa Jacket",
    price: "$228.00",
    location: "SOHO"
  },
  { 
    img: "https://cdn.shopify.com/s/files/1/2185/2813/files/W6289R_00_b2_s1_a1_1_m186_640x.jpg", 
    brand: "Alo", 
    name: "Grand Slam Tennis Skirt", 
    price: "$98.00", 
    location: "Flatiron" 
  },
  { 
    img: "https://assets.aritzia.com/image/upload/q_auto,f_auto,dpr_auto/s25_a02_125544_10006_on_a", 
    brand: "Aritzia", 
    name: "Mondrian Top", 
    price: "128.00", 
    location: "SoHo Flagship" 
  },
  { 
    img: "https://assets.aritzia.com/image/upload/q_auto,f_auto,dpr_auto/s25_a08_125516_12947_on_a", 
    brand: "Aritzia", 
    name: "Nomi Dress", 
    price: "38.99", 
    location: "Fifth Ave Flagship" 
  },
  { 
    img: "https://cdn.shopify.com/s/files/1/2185/2813/products/A0518U_01_b1_a1_640x.jpg", 
    brand: "Alo", 
    name: "Performance Conquer Headband", 
    price: "$34.00", 
    location: "Flatiron" 
  },
  { 
    img: "https://danielleguiziony.com/cdn/shop/files/GUIZIO_ECOMM2051.jpg", 
    brand: "Guizio", 
    name: "Ara Top", 
    price: "$178.00", 
    location: "NYC Flagship" 
  },
  {
    img: "https://static.zara.net/assets/public/aba8/7747/33284ac3a257/e79b70c92f6b/05479111705-e1/05479111705-e1.jpg?ts=1763623822492&w=518",
    brand: "ZARA",
    name: "AARON LEVINE X ZARA CROPPED SUEDE LEATHER JACKET",
    price: "$59.80",
    originalPrice: "$299.00",
    discount: "-80%",
    location: "SOHO"
  },
  {
    img: "https://cdn.media.amplience.net/i/vince/V179952039_788SNI_001/Floral-Jacquard-Satin-Slip-Dress-788SNI/$customColor$?$medium$",
    brand: "Vince",
    name: "Floral Jacquard Satin Slip Dress",
    price: "$418.60",
    originalPrice: "$598.00",
    discount: "-30%",
    location: "SoHo"
  },
  {
    img: "https://static.zara.net/assets/public/21b4/7b06/4bb9450daeca/f7699aed8121/01564106401-e1/01564106401-e1.jpg?ts=1766069801447&w=518",
    brand: "ZARA",
    name: "DOUBLE BREASTED SUIT BLAZER",
    price: "$33.80",
    originalPrice: "$169.00",
    discount: "-80%",
    location: "660 5th Avenue"
  },
  {
    img: "https://static.zara.net/assets/public/433d/a792/fcd5485894df/391e6ce6c1f6/01758147300-a1/01758147300-a1.jpg?ts=1777033901458&w=538",
    brand: "ZARA",
    name: "100% VISCOSE LONG DRESS",
    price: "$33.80",
    originalPrice: "$169.00",
    discount: "-80%",
    location: "SOHO"
  },
  {
    img: "https://cdn.media.amplience.net/i/vince/V183779879_137OWT_001/Honeycomb-Italian-Cotton--Linen-Blend-Short-Sleeve-Sweater-137OWT/$customColor$?$medium$",
    brand: "Vince",
    name: "Honeycomb Italian Cotton & Linen-Blend Short-Sleeve Sweater",
    price: "$313.60",
    originalPrice: "$448.00",
    discount: "-30%",
    location: "SoHo"
  },
  {
    img: "https://static.zara.net/assets/public/5fa3/71b0/18f84c109a54/6e003ad6b66d/04393441803-e1/04393441803-e1.jpg?ts=1774373656105&w=518",
    brand: "ZARA",
    name: "WILLY CHAVARRIA X ZARA RELAXED FIT HOODIE",
    price: "$23.80",
    originalPrice: "$119.00",
    discount: "-80%",
    location: "SOHO"
  },
  { 
    img: "https://skims.imgix.net/s/files/1/0259/5448/4284/files/TP-TSH-5701M-LHG-TB-SKIMS-MENS_0001-FR.jpg?v=1738174592&auto=format&w=600&fp-z=1&fp-y=0.5&fp-x=0.5&crop=focalpoint&fit=crop&ixlib=react-9.10.0", 
    brand: "Skims", 
    name: "MENS CLASSIC T-SHIRT", 
    price: "$15.00", 
    location: "NYC Flagship" 
  },
  { 
    img: "https://cdn.shopify.com/s/files/1/0512/3103/1472/files/lana-top-stone-with-jean-01.jpg", 
    brand: "withjean", 
    name: "Lana Top | Stone", 
    price: "$148.00", 
    location: "NYC" 
  },
  { 
    img: "https://cdn.shopify.com/s/files/1/2185/2813/files/M1224R_01_b1_s1_a1_1_m221_640x.jpg", 
    brand: "Alo", 
    name: "Double Take Short Sleeve", 
    price: "$88.00", 
    location: "SOHO" 
  },
  { 
    img: "https://cdn.shopify.com/s/files/1/2185/2813/files/M1205R_06646_b1_s1_a2_m214_640x.jpg?v=1761902724", 
    brand: "Alo", 
    name: "Conquer Reform Crewneck Short Sleeve", 
    price: "$78.00", 
    location: "Flatiron" 
  },
  { 
    img: "https://www1.assets-gap.com/webcontent/0059/070/420/cn59070420.jpg?q=h&w=768", 
    brand: "Banana Republic", 
    name: "COTTON-LINEN RESORT SWEATER POLO", 
    price: "$120.00", 
    location: "Flatiron" 
  },
  { 
    img: "https://www.victoriassecret.com/p/380x507/png/zz/26/04/23/02/112865517L0D_OM_F.jpg", 
    brand: "Victoria's Secret", 
    name: "Denim Mesh Ruffled Cheeky Panty", 
    price: "$18.95", 
    location: "Fifth Ave" 
  },
  { 
    img: "https://skims.imgix.net/s/files/1/0259/5448/4284/files/AP-DRS-0596-ONX-HC-SKIMS-LOUNGEWEAR_3140-FR.jpg?v=1708554715&auto=format&w=600&fp-z=1&fp-y=0.5&fp-x=0.5&crop=focalpoint&fit=crop&ixlib=react-9.10.0", 
    brand: "Skims", 
    name: "Long Slip Dress", 
    price: "$80.00", 
    location: "Flagship" 
  },
  {
    img: "https://assets.aritzia.com/image/upload/c_crop,ar_1920:2623,g_south/q_auto,f_auto,dpr_auto/s26_a08_131727_36523_on_a",
    brand: "Aritzia",
    name: "Encino Dress",
    price: "$58.99",
    originalPrice: "$148.00",
    discount: "-60%",
    location: "Fifth Ave Flagship"
  },
  {
    img: "https://danielleguiziony.com/cdn/shop/files/OCT144685_4f33b0db-4f65-4aa7-a2c3-95cfadd0bc85.jpg?v=1761235235&width=960",
    brand: "GUIZIO",
    name: "Monroe Faux Fur Coat",
    price: "$246.00",
    originalPrice: "$328.00",
    discount: "-25%",
    location: "NYC Flagship"
  },
  {
    img: "https://images.ctfassets.net/hnk2vsx53n6l/2Qn2eAGnpNho9ivU5TzyaF/dcabd5842c99a37fff0f4f8429e5ac58/59259ddaeda674ba4e72621ca51217b8d6e40d85.jpg?w=1500&h=1500&fm=jpg&fl=progressive&f=center&fit=fill&q=80",
    brand: "On",
    name: "Core Jacket",
    price: "$120.00",
    originalPrice: "$200.00",
    discount: "-40%",
    location: "NYC Flagship"
  },
  {
    img: "https://static.zara.net/assets/public/7a9e/29c3/ff6e49288a39/debbd15f6186/07627043104-p/07627043104-p.jpg?ts=1767007811678&w=1024",
    brand: "ZARA",
    name: "ZW COLLECTION WIDE LEG PANTS",
    price: "$19.98",
    originalPrice: "$99.90",
    discount: "-80%",
    location: "660 5th Avenue"
  },
  {
    img: "https://us.princesspolly.com/cdn/shop/files/0-modelinfo-selina-us2_44ad768b-f65a-4fcf-9918-06bfd3bbeb1d_373x506_crop_center.jpg?v=1772750306",
    brand: "PRINCESS POLLY",
    name: "Celena Maxi Dress Burgundy Burnout",
    price: "$29.50",
    originalPrice: "$99.00",
    discount: "-70%",
    location: "Broadway"
  },
  { 
    img: "https://qf-images-8-1.s3.us-east-1.amazonaws.com/Image-1.png", 
    brand: "Alo", 
    name: "Long Sleeve Ribbed Top", 
    price: "$68.00", 
    location: "SOHO" 
  },
  { 
    img: "https://qf-images-8-1.s3.us-east-1.amazonaws.com/Image-7.png", 
    brand: "Skims", 
    name: "Cotton Rib Tank", 
    price: "$36.00", 
    location: "Flagship" 
  },
  { 
    img: "https://qf-images-8-1.s3.us-east-1.amazonaws.com/Image-1-Male.png", 
    brand: "Alo", 
    name: "Long Sleeve Ribbed Top (Mens)", 
    price: "$68.00", 
    location: "Flatiron" 
  },
  { 
    img: "https://qf-images-8-1.s3.us-east-1.amazonaws.com/Image-2-Male.png", 
    brand: "Skims", 
    name: "Cotton Rib Tank (Mens)", 
    price: "$36.00", 
    location: "Flagship" 
  }
];

const extendedCarouselData = [
  ...carouselData,
  { isSeeMore: true, link: "https://apps.apple.com/us/app/quickfit-inc/id6745117626" }
];

const PopularSearches = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const visibleItemsCount = 4; 

  const nextSlide = () => {
    if (currentIndex < extendedCarouselData.length - visibleItemsCount) {
        setCurrentIndex((prevIndex) => prevIndex + 1);
    }
  };

  const prevSlide = () => {
    if (currentIndex > 0) {
        setCurrentIndex((prevIndex) => prevIndex - 1);
    }
  };

  const visibleItems = extendedCarouselData.slice(
      currentIndex, 
      currentIndex + visibleItemsCount
  );

  return (
    <section className="popular-searches">
      <h2>Popular Searches</h2>
      <div className="carousel">
        <button
          className="carousel-arrow left"
          onClick={prevSlide}
          disabled={currentIndex === 0}
        >
          &lt;
        </button>
        
        <div className="carousel-items">
          {visibleItems.map((item) => {
            if (item.isSeeMore) {
              return (
                <a 
                  key="see-more-popular"
                  href={item.link} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="carousel-item see-more-popular-card"
                >
                  <div className="see-more-icon-wrapper">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                      <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                  </div>
                  <span className="see-more-text">See More</span>
                </a>
              );
            }

            return (
              <div className="carousel-item" key={item.name}>
                <div className="carousel-image-wrapper">
                  {item.discount && (
                    <span className="discount-badge">{item.discount}</span>
                  )}
                  <img src={item.img} alt={item.name} />
                </div>
                
                <div className="brand-location-row">
                  <span className="brand-name">{item.brand}</span>
                  <span className="location-info">
                    <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 0C2.65 0 0.75 1.9 0.75 4.25C0.75 7.25 5 12 5 12C5 12 9.25 7.25 9.25 4.25C9.25 1.9 7.35 0 5 0ZM5 5.75C4.17 5.75 3.5 5.08 3.5 4.25C3.5 3.42 4.17 2.75 5 2.75C5.83 2.75 6.5 3.42 6.5 4.25C6.5 5.08 5.83 5.75 5 5.75Z" fill="#888888"/>
                    </svg>
                    {item.location}
                  </span>
                </div>

                <p className="item-name">{item.name}</p>
                
                <div className="item-price-row">
                  {item.originalPrice && (
                    <span className="original-price">{item.originalPrice}</span>
                  )}
                  <span className={item.originalPrice ? "sale-price" : "item-price"}>
                    {item.price}
                  </span>
                </div>
              </div>
            );
          })}
        </div>

        <button
          className="carousel-arrow right"
          onClick={nextSlide}
          disabled={currentIndex >= extendedCarouselData.length - visibleItemsCount}
        >
          &gt;
        </button>
      </div>

      <div className="view-catalog-wrapper">
        <a 
          href="https://apps.apple.com/us/app/quickfit-inc/id6745117626" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="view-catalog-btn"
        >
          View Catalog
        </a>
      </div>

    </section>
  );
};

export default PopularSearches;